/**
 * Analisi comparative di tutte le gare.
 *
 * Per la Direzione è la coda delle decisioni: di default mostra le Bozze, cioè le analisi che
 * l'Ufficio Acquisti ha salvato e che aspettano un'approvazione.
 */

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { analisiApi } from "../services/acquistiApi";
import { Campo, Scelta, Caricamento, Vuoto, Avviso } from "../components/campi";
import {
  STATO_ANALISI,
  STATO_ANALISI_BADGE,
  ANALISI_BOZZA,
  opzioni,
} from "../constants/optionSet";
import { etichetta } from "../utils/formato";

export default function AnalisiPage() {
  const [stato, setStato] = useState(String(ANALISI_BOZZA));
  const [analisi, setAnalisi] = useState([]);
  const [caricamento, setCaricamento] = useState(true);
  const [errore, setErrore] = useState(null);

  useEffect(() => {
    setCaricamento(true);
    analisiApi
      .list({ stato })
      .then((r) => {
        setAnalisi(r.value || []);
        setErrore(null);
      })
      .catch((e) => setErrore(e.message))
      .finally(() => setCaricamento(false));
  }, [stato]);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-end gap-3">
        <h1 className="text-xl font-semibold text-gray-900">
          Analisi comparative
        </h1>
        <div className="ml-auto w-56">
          <Campo label="Stato">
            <Scelta
              valore={stato}
              onChange={setStato}
              opzioni={opzioni(STATO_ANALISI)}
              vuoto="tutte"
            />
          </Campo>
        </div>
      </div>

      {errore && <Avviso tipo="errore">{errore}</Avviso>}

      <div className="card !p-0 overflow-x-auto">
        {caricamento ? (
          <Caricamento />
        ) : analisi.length === 0 ? (
          <Vuoto
            titolo={
              stato === String(ANALISI_BOZZA)
                ? "Nessuna analisi da approvare"
                : "Nessuna analisi"
            }
          >
            Un'analisi nasce quando l'Ufficio Acquisti salva la comparazione di
            una gara in valutazione.
          </Vuoto>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Gara</th>
                <th>Versione</th>
                <th>Stato</th>
                <th>Salvata</th>
                <th>Esito</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {analisi.map((a) => (
                <tr key={a.id}>
                  <td>
                    <Link
                      to={`/gare/${a.garaId}/comparazione?analisi=${a.id}`}
                      className="text-acquisti-700 hover:underline font-medium"
                    >
                      {a.gara ? `${a.gara.codice} ${a.gara.nome}` : a.nome}
                    </Link>
                  </td>
                  <td>v{a.versione}</td>
                  <td>
                    <span
                      className={STATO_ANALISI_BADGE[a.stato] || "badge-gray"}
                    >
                      {etichetta(STATO_ANALISI, a.stato)}
                    </span>
                  </td>
                  <td className="text-sm">
                    {a.creataIl
                      ? new Date(a.creataIl).toLocaleDateString("it-IT")
                      : "—"}
                    {a.creataDa ? ` · ${a.creataDa}` : ""}
                  </td>
                  <td className="text-sm">
                    {a.fornitoreVincitore
                      ? `${a.fornitoreVincitore.nome} (${a.punteggioVincente})`
                      : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
